import React, { useContext, useEffect, useRef } from "react";
import { GetPagePermission } from "../../components/UserPagePermission";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import userPermissionContext from '../../../context/userPermissionContext';
import { KTSVG } from '../../../_metronic/helpers';
import BackendTable from 'react-backend-table';
import { formatBdt } from '../../helpers/formatBdt';

function OperatingCostSummaryReport() {
    const { jwt, businessUnit } = useContext(userPermissionContext);
    const hasPermission = GetPagePermission('/report-operatingCostSummaryReport');

    const backendTableRef = useRef(null);

    const columns = [
        {
            title: 'SL',
            field: 'serial',
            sortable: true,
            searchable: false,
            thStyle: { textAlign: 'center' },
            tdStyle: { textAlign: 'center' },
        },
        {
            title: 'Month',
            field: 'monthLabel',
            sortable: true,
            searchable: true,
        },
        {
            title: 'Monthly Total Cost',
            field: 'totalCost',
            sortable: true,
            searchable: true,
            thStyle: { textAlign: 'right' },
            tdStyle: { textAlign: 'right' },
            hasComponent: true,
            componentValue: (rowValue) => formatBdt(rowValue?.totalCost),
        },
    ];

    const options = {
        url: process.env.REACT_APP_API_URL + 'operatingCostSummaryReport?currentProject=' + businessUnit.idProjects,
        authorization: 'Bearer ' + jwt.token,
        perPage: [12, 24, 50, 'All'],
        orderBy: 'monthKey',
        orderType: 'desc',
        columnSearch: true,
        extraData: {},
    };

    useEffect(() => {
        backendTableRef.current?.reload();
    }, [businessUnit]);

    return (
        <>
            {hasPermission === 1 &&
                <div className="card card-custom">
                    <div className="card-header d-flex flex-direction-row justify-content-between py-4">
                        <div className="card-title w-50">
                            <KTSVG
                                path="/media/svg/icons/Shopping/Money.svg"
                                className="svg-icon-1 svg-icon-primary"
                            />
                            <span className="text fw-bolder" style={{ marginLeft: "10px" }}>
                                OPERATING COST SUMMARY REPORT
                            </span>
                        </div>
                    </div>

                    <div className="ml-12">
                        <div className="" style={{ overflowX: "hidden" }}>
                            <BackendTable ref={backendTableRef} columns={columns} options={options} />
                        </div>
                    </div>
                </div>
            }
            {hasPermission === 0 &&
                <div className="card card-custom" style={{ padding: "15px" }}>
                    <SkeletonTheme>
                        <p>
                            <Skeleton
                                containerClassName="avatar-skeleton"
                                count={40}
                            ></Skeleton>
                        </p>
                    </SkeletonTheme>
                </div>
            }
        </>
    );
}

export default OperatingCostSummaryReport;
